import styled from "styled-components";

export const ResetPasswordFormStyles = styled.div`
  .buttonContainer {
    display: flex;
    justify-content: flex-end;
  }
`;
